module.exports = __webpack_public_path__ + "img/4_of_Diamonds.svg.4b4a6976.png";